export function generatePeriods(startYear, endYear) {
    const periods = [];
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const quarterNames = ["Q1", "Q2", "Q3", "Q4"];

    for (let year = startYear; year <= endYear; year++) {
        // Add year
        periods.push({
            id: `year_${year}`,
            name: `FY ${year}`,
            type: "year",
            startDate: { seconds: new Date(year, 0, 1).getTime() / 1000, nanoseconds: 0 },
            endDate: { seconds: new Date(year + 1, 0, 1).getTime() / 1000 - 1, nanoseconds: 0 }
        });

        // Add quarters
        for (let q = 0; q < 4; q++) {
            periods.push({
                id: `quarter_${q + 1}_${year}`,
                name: `${quarterNames[q]} ${year}`,
                type: "quarter",
                parentIndex: `year_${year}`,
                startDate: { seconds: new Date(year, q * 3, 1).getTime() / 1000, nanoseconds: 0 },
                endDate: { seconds: new Date(year, (q + 1) * 3, 1).getTime() / 1000 - 1, nanoseconds: 0 }
            });

            // Add months
            for (let m = 0; m < 3; m++) {
                const monthIndex = q * 3 + m;
                periods.push({
                    id: `month_${monthIndex + 1}_${year}`,
                    name: `${monthNames[monthIndex]} ${year}`,
                    type: "month",
                    parentIndex: `quarter_${q + 1}_${year}`,
                    startDate: { seconds: new Date(year, monthIndex, 1).getTime() / 1000, nanoseconds: 0 },
                    endDate: { seconds: new Date(year, monthIndex + 1, 1).getTime() / 1000 - 1, nanoseconds: 0 }
                });
            }
        }
    }

    return periods;
}

export function getHierarchicalPeriods(startY, endY) {
    // console.log("🚀 ~ hierarchicalPeriods ~ years:", periods);
    const periods = generatePeriods(startY, endY);
    const years = periods
      .filter((period) => period.type === "year")
      .sort((a, b) => {
        const yearA = parseInt(a.name.match(/\d+/)[0], 10);
        const yearB = parseInt(b.name.match(/\d+/)[0], 10);

        return  yearB - yearA; 
      });
    // console.log('periods:', periods);
    //console.log("🚀 ~ hierarchicalPeriods ~ years:", years)
    const quarters = periods.filter(
      (period) => period.type === "quarter"
    ).sort((a, b) => {
        const quarterA = parseInt(a.name.match(/\d+/)[0], 10);
        const quarterB = parseInt(b.name.match(/\d+/)[0], 10);

        return  quarterA - quarterB; 
      }
    );
    const months = periods.filter((period) => period.type === "month")
    .sort((a, b) => {
        // "month_4_2024"
        const monthA = parseInt(a.id.match(/\d+/)[0], 10);
        const monthB = parseInt(b.id.match(/\d+/)[0], 10);
        // console.log(a)
        return  monthA - monthB; 
      });

    const result = years.flatMap((year) => [
      { ...year, level: 0 },
      ...quarters
        .filter((quarter) => quarter.parentIndex === year.id)
        .flatMap((quarter) => [
          { ...quarter, level: 1 },
          ...months
            .filter((month) => month.parentIndex === quarter.id)
            .map((month) => ({ ...month, level: 2 })),
        ]),
    ]);
    // console.log('result:', result);
    return result;
}

export function getCurrentPeriodMonth(periods) {
    const today = new Date();
    const currentPeriod = periods.find((period) => {
        if (period.type !== "month") return false;
        const startDate = new Date(period.startDate.seconds * 1000);
        const endDate = new Date(period.endDate.seconds * 1000);
        return today >= startDate && today <= endDate;
    });

    return currentPeriod;
}